import { BACKEND_LANG_MAP } from './langs'

// 把 locale 转换为后端语言码并设置到 http 头
export function setRequestLangHeaders(http: any, locale: string) {
  const backendCode = BACKEND_LANG_MAP[locale] ?? locale
  http.defaults.headers.common['Accept-Language'] = backendCode
  http.defaults.headers.common['X-App-Lang'] = backendCode
}

// 同步 <html lang>，利于可访问性与 SEO
export function setHtmlLang(locale: string) {
  document?.querySelector('html')?.setAttribute('lang', locale)
}
